import { Component } from '@angular/core';

import { MouseMode } from '../../models/mouse-mode';
import { ITool } from '../../models/tool';
import { MouseModeService } from '../../services/mouse-state.service';

const DRAWING_TOOLS: ITool[] = [ {
    name: 'Highlight an area',
    svgName: 'highlight-pen',
    mouseMode: MouseMode.DRAW_AREA_X
}, {
    name: 'Draw a vertical line',
    svgName: 'vertical-line-pen',
    mouseMode: MouseMode.DRAW_LINE_X
}, {
    name: 'Draw a horizontal line',
    svgName: 'horizontal-line-pen',
    mouseMode: MouseMode.DRAW_LINE_Y
}, {
    name: 'Draw a line segment',
    svgName: 'line-segment-pen',
    mouseMode: MouseMode.DRAW_LINE_SEGMENT
}, {
    name: 'Add or edit a text bubble',
    iconName: 'add_comment',
    mouseMode: MouseMode.ADD_TEXT_BUBBLE
} ];

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-drawing-tools',
    templateUrl: './tools.component.html',
    styleUrls: [ './annotations.component.scss' ]
})
export class DrawingToolsComponent  {
    tools = DRAWING_TOOLS;
    activeTool: ITool;

    constructor( private _mouseModeService: MouseModeService ) {
        this.activeTool = this.tools[0];
    }

    selectTool( tool: ITool ) {
        this.activeTool = tool;
        this._mouseModeService.setMouseMode( tool.mouseMode );
    }
}
